export enum OfferFailReason {
	None = 0,
	NoFertigerCanProduce = 1,
	NoFertigerHasDeliveryDate = 2,
}
